// Export an array of topics for VA 1st Grade Science
const md2ndSocialStudiesQuizContent = [
  // Past and Present - Multiple Choice
  {
    "slug": "pastandpresent",
    "title": "Past and Present",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. In the past, how were most buildings described in the song?",
        "questionImage": "",
        "answers": [
          { "text": "Smaller", "correct": true, "image": "" },
          { "text": "Taller", "correct": false, "image": "" },
          { "text": "Same size", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. According to the lyrics, how do most people wash clothes in the present?",
        "questionImage": "",
        "answers": [
          { "text": "With machines", "correct": true, "image": "" },
          { "text": "In a river", "correct": false, "image": "" },
          { "text": "By hand", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What tool did people use for writing and typing in the past?",
        "questionImage": "",
        "answers": [
          { "text": "Typewriter", "correct": true, "image": "" },
          { "text": "Tablet", "correct": false, "image": "" },
          { "text": "Phone", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. In the song, what is an invention described as?",
        "questionImage": "",
        "answers": [
          { "text": "A new idea", "correct": true, "image": "" },
          { "text": "A rule", "correct": false, "image": "" },
          { "text": "A holiday", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What does the word 'population' mean in the lyrics?",
        "questionImage": "",
        "answers": [
          { "text": "Number of people", "correct": true, "image": "" },
          { "text": "Weather", "correct": false, "image": "" },
          { "text": "Animals", "correct": false, "image": "" }
        ]
      }
    ]
  },
  

  // Pueblo and Lakota - Drag and Drop
  {
    "slug": "puebloandlakota",
    "title": "Pueblo and Lakota",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each Native group to the region where they lived.",
        "options": [
          { "id": "pueblo", "text": "Pueblo", "image": "", "targetText": "Southwest", "targetImage": "" },
          { "id": "lakota", "text": "Lakota", "image": "", "targetText": "Plains", "targetImage": "" },
          { "id": "powhatan", "text": "Powhatan", "image": "", "targetText": "Eastern Woodlands", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each group to the type of homes they built.",
        "options": [
          { "id": "pueblo_home", "text": "Pueblo", "image": "", "targetText": "Clay homes", "targetImage": "" },
          { "id": "lakota_home", "text": "Lakota", "image": "", "targetText": "Teepees", "targetImage": "" },
          { "id": "powhatan_home", "text": "Powhatan", "image": "", "targetText": "Wood houses", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each group to the kind of work they did.",
        "options": [
          { "id": "pueblo_work", "text": "Pueblo", "image": "", "targetText": "Farmed and hunted", "targetImage": "" },
          { "id": "lakota_work", "text": "Lakota", "image": "", "targetText": "Hunted buffalo", "targetImage": "" },
          { "id": "powhatan_work", "text": "Powhatan", "image": "", "targetText": "Fished and farmed", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each group to their main way of travel.",
        "options": [
          { "id": "pueblo_travel", "text": "Pueblo", "image": "", "targetText": "Walked", "targetImage": "" },
          { "id": "lakota_travel", "text": "Lakota", "image": "", "targetText": "Rode horses", "targetImage": "" },
          { "id": "powhatan_travel", "text": "Powhatan", "image": "", "targetText": "Canoes", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each art or craft to the group known for it.",
        "options": [
          { "id": "pueblo_art", "text": "Pottery", "image": "", "targetText": "Pueblo", "targetImage": "" },
          { "id": "lakota_art", "text": "Beadwork", "image": "", "targetText": "Lakota", "targetImage": "" },
          { "id": "powhatan_art", "text": "Carving", "image": "", "targetText": "Powhatan", "targetImage": "" }
        ]
      }
    ]
  },
  

  // Native Differences - Multiple Choice
  {
    "slug": "nativedifferences",
    "title": "Native Differences",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. In which region did the Powhatan live according to the song?",
        "questionImage": "",
        "answers": [
          { "text": "Eastern Woodlands", "correct": true, "image": "" },
          { "text": "Plains", "correct": false, "image": "" },
          { "text": "Desert", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What kind of homes did the Lakota build as described in the lyrics?",
        "questionImage": "",
        "answers": [
          { "text": "Teepees", "correct": true, "image": "" },
          { "text": "Igloos", "correct": false, "image": "" },
          { "text": "Castles", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What were Pueblo homes made from according to the song?",
        "questionImage": "",
        "answers": [
          { "text": "Clay", "correct": true, "image": "" },
          { "text": "Ice", "correct": false, "image": "" },
          { "text": "Bark", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What kinds of jobs did the Powhatan do as mentioned in the song?",
        "questionImage": "",
        "answers": [
          { "text": "Hunted, fished, and farmed", "correct": true, "image": "" },
          { "text": "Mined gold", "correct": false, "image": "" },
          { "text": "Built cities", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. How did the Powhatan travel as mentioned in the lyrics?",
        "questionImage": "",
        "answers": [
          { "text": "Canoes", "correct": true, "image": "" },
          { "text": "Horses", "correct": false, "image": "" },
          { "text": "Trains", "correct": false, "image": "" }
        ]
      }
    ]
  },
  

  // Benjamin Franklin - Multiple Choice
  {
    "slug": "benjaminfranklin",
    "title": "Benjamin Franklin",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. Which useful item for seeing clearly did Benjamin Franklin invent?",
        "questionImage": "",
        "answers": [
          { "text": "Bifocals", "correct": true, "image": "" },
          { "text": "Telephone", "correct": false, "image": "" },
          { "text": "Airplane", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What did Franklin’s kite experiment help show about lightning?",
        "questionImage": "",
        "answers": [
          { "text": "It’s electricity", "correct": true, "image": "" },
          { "text": "It’s wind", "correct": false, "image": "" },
          { "text": "It’s water", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which important United States document did Benjamin Franklin help write?",
        "questionImage": "",
        "answers": [
          { "text": "Declaration of Independence", "correct": true, "image": "" },
          { "text": "Bill of Rights", "correct": false, "image": "" },
          { "text": "Constitution", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which other key American document did Benjamin Franklin sign?",
        "questionImage": "",
        "answers": [
          { "text": "U.S. Constitution", "correct": true, "image": "" },
          { "text": "Gettysburg Address", "correct": false, "image": "" },
          { "text": "Homestead Act", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Was Benjamin Franklin ever President of the United States?",
        "questionImage": "",
        "answers": [
          { "text": "No", "correct": true, "image": "" },
          { "text": "Yes", "correct": false, "image": "" },
          { "text": "Not sure", "correct": false, "image": "" }
        ]
      }
    ]
  },
  

  // Abraham Lincoln - Multiple Choice
  {
    "slug": "abrahamlincoln",
    "title": "Abraham Lincoln",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What number President of the United States was Abraham Lincoln?",
        "questionImage": "",
        "answers": [
          { "text": "16th", "correct": true, "image": "" },
          { "text": "1st", "correct": false, "image": "" },
          { "text": "26th", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. In which state was Abraham Lincoln born?",
        "questionImage": "",
        "answers": [
          { "text": "Kentucky", "correct": true, "image": "" },
          { "text": "Virginia", "correct": false, "image": "" },
          { "text": "Ohio", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What major action is Abraham Lincoln best known for?",
        "questionImage": "",
        "answers": [
          { "text": "Freed slaves", "correct": true, "image": "" },
          { "text": "Bought Alaska", "correct": false, "image": "" },
          { "text": "Built the White House", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which war took place while Abraham Lincoln was President?",
        "questionImage": "",
        "answers": [
          { "text": "Civil War", "correct": true, "image": "" },
          { "text": "World War I", "correct": false, "image": "" },
          { "text": "Revolutionary War", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What job did Abraham Lincoln have before becoming President?",
        "questionImage": "",
        "answers": [
          { "text": "Lawyer", "correct": true, "image": "" },
          { "text": "Sailor", "correct": false, "image": "" },
          { "text": "Teacher", "correct": false, "image": "" }
        ]
      }
    ]
  },
  

  // Equal Rights - Drag and Drop
  {
    "slug": "equalrights",
    "title": "Equal Rights",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each leader to the cause they are known for in the song.",
        "options": [
          { "id": "sba", "text": "Susan B. Anthony", "image": "", "targetText": "Women's voting rights", "targetImage": "" },
          { "id": "jr", "text": "Jackie Robinson", "image": "", "targetText": "First in Major League Baseball", "targetImage": "" },
          { "id": "mlk", "text": "Martin Luther King Jr.", "image": "", "targetText": "Civil rights leader", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each person to their civil rights role from the verse.",
        "options": [
          { "id": "tm", "text": "Thurgood Marshall", "image": "", "targetText": "Supreme Court Justice", "targetImage": "" },
          { "id": "rp", "text": "Rosa Parks", "image": "", "targetText": "Refused to give up her seat", "targetImage": "" },
          { "id": "sba2", "text": "Susan B. Anthony", "image": "", "targetText": "Fought for equal rights", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each person to the protest or change they helped inspire.",
        "options": [
          { "id": "rp2", "text": "Rosa Parks", "image": "", "targetText": "Bus boycott", "targetImage": "" },
          { "id": "mlk2", "text": "Martin Luther King Jr.", "image": "", "targetText": "Peaceful marches", "targetImage": "" },
          { "id": "jr2", "text": "Jackie Robinson", "image": "", "targetText": "Sports equality", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each name to the job title connected to them in the lyrics.",
        "options": [
          { "id": "mlk_job", "text": "Martin Luther King Jr.", "image": "", "targetText": "Minister", "targetImage": "" },
          { "id": "tm_job", "text": "Thurgood Marshall", "image": "", "targetText": "Justice", "targetImage": "" },
          { "id": "jr_job", "text": "Jackie Robinson", "image": "", "targetText": "Athlete", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each person to the field where they first broke a barrier.",
        "options": [
          { "id": "sba_field", "text": "Susan B. Anthony", "image": "", "targetText": "Voting rights", "targetImage": "" },
          { "id": "jr_field", "text": "Jackie Robinson", "image": "", "targetText": "Baseball", "targetImage": "" },
          { "id": "tm_field", "text": "Thurgood Marshall", "image": "", "targetText": "Law and courts", "targetImage": "" }
        ]
      }
    ]
  },
  

  // Dr. Martin Luther King Jr. - Multiple Choice
  {
    "slug": "drmartinlutherkingjr",
    "title": "Dr. Martin Luther King Jr.",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. Which major award did Dr. Martin Luther King Jr. receive according to the song?",
        "questionImage": "",
        "answers": [
          { "text": "Nobel Peace Prize", "correct": true, "image": "" },
          { "text": "Oscar Award", "correct": false, "image": "" },
          { "text": "Grammy Award", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. In what year was Dr. Martin Luther King Jr. born as stated in the lyrics?",
        "questionImage": "",
        "answers": [
          { "text": "1929", "correct": true, "image": "" },
          { "text": "1919", "correct": false, "image": "" },
          { "text": "1940", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What is the famous speech by Dr. King mentioned in the song?",
        "questionImage": "",
        "answers": [
          { "text": "I Have a Dream", "correct": true, "image": "" },
          { "text": "Four Freedoms", "correct": false, "image": "" },
          { "text": "New Frontier", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What was Dr. King’s job as described in the song?",
        "questionImage": "",
        "answers": [
          { "text": "Minister", "correct": true, "image": "" },
          { "text": "General", "correct": false, "image": "" },
          { "text": "Judge", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What did Dr. Martin Luther King Jr. work to achieve for people?",
        "questionImage": "",
        "answers": [
          { "text": "Equal rights", "correct": true, "image": "" },
          { "text": "More wars", "correct": false, "image": "" },
          { "text": "New taxes", "correct": false, "image": "" }
        ]
      }
    ]
  },
  

  // Holiday - Drag and Drop
  {
    "slug": "holiday",
    "title": "Holiday",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each month to the holiday celebrated in that month.",
        "options": [
          { "id": "jan", "text": "January", "image": "", "targetText": "Martin Luther King Jr. Day", "targetImage": "" },
          { "id": "feb", "text": "February", "image": "", "targetText": "Presidents Day", "targetImage": "" },
          { "id": "mar", "text": "March", "image": "", "targetText": "Women’s History Month", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each spring month to the holiday or event remembered.",
        "options": [
          { "id": "apr", "text": "April", "image": "", "targetText": "Earth Day", "targetImage": "" },
          { "id": "may", "text": "May", "image": "", "targetText": "Memorial Day", "targetImage": "" },
          { "id": "jun", "text": "June", "image": "", "targetText": "Flag Day", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each summer holiday to the correct month.",
        "options": [
          { "id": "jul", "text": "July", "image": "", "targetText": "Independence Day", "targetImage": "" },
          { "id": "aug", "text": "August", "image": "", "targetText": "Back to School Month", "targetImage": "" },
          { "id": "sep", "text": "September", "image": "", "targetText": "Labor Day", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match the fall months to the holidays celebrated then.",
        "options": [
          { "id": "oct", "text": "October", "image": "", "targetText": "Halloween", "targetImage": "" },
          { "id": "nov", "text": "November", "image": "", "targetText": "Veterans Day", "targetImage": "" },
          { "id": "nov2", "text": "November", "image": "", "targetText": "Thanksgiving", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each winter month to the holiday mentioned in the song.",
        "options": [
          { "id": "dec", "text": "December", "image": "", "targetText": "Christmas", "targetImage": "" },
          { "id": "dec2", "text": "December", "image": "", "targetText": "Kwanzaa", "targetImage": "" },
          { "id": "jan2", "text": "January", "image": "", "targetText": "New Year’s Day", "targetImage": "" }
        ]
      }
    ]
  },
  

  // Continents and Oceans - Drag and Drop
  {
    "slug": "continentsandoceans",
    "title": "Continents and Oceans",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each name to whether it is a continent or an ocean.",
        "options": [
          { "id": "af", "text": "Africa", "image": "", "targetText": "Continent", "targetImage": "" },
          { "id": "eu", "text": "Europe", "image": "", "targetText": "Continent", "targetImage": "" },
          { "id": "na", "text": "North America", "image": "", "targetText": "Continent", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Continue matching the names to the correct category.",
        "options": [
          { "id": "sa", "text": "South America", "image": "", "targetText": "Continent", "targetImage": "" },
          { "id": "as", "text": "Asia", "image": "", "targetText": "Continent", "targetImage": "" },
          { "id": "an", "text": "Antarctica", "image": "", "targetText": "Continent", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Finish the continent matches by placing each name in the correct group.",
        "options": [
          { "id": "au", "text": "Australia", "image": "", "targetText": "Continent", "targetImage": "" },
          { "id": "af2", "text": "Africa", "image": "", "targetText": "Continent", "targetImage": "" },
          { "id": "eu2", "text": "Europe", "image": "", "targetText": "Continent", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each ocean name to the word Ocean.",
        "options": [
          { "id": "pac", "text": "Pacific Ocean", "image": "", "targetText": "Ocean", "targetImage": "" },
          { "id": "atl", "text": "Atlantic Ocean", "image": "", "targetText": "Ocean", "targetImage": "" },
          { "id": "ind", "text": "Indian Ocean", "image": "", "targetText": "Ocean", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Complete the ocean matches by placing each remaining name with Ocean.",
        "options": [
          { "id": "arc", "text": "Arctic Ocean", "image": "", "targetText": "Ocean", "targetImage": "" },
          { "id": "sou", "text": "Southern Ocean", "image": "", "targetText": "Ocean", "targetImage": "" },
          { "id": "pac2", "text": "Pacific Ocean", "image": "", "targetText": "Ocean", "targetImage": "" }
        ]
      }
    ]
  },
  

  // Hemisphere - Multiple Choice
  {
    "slug": "hemisphere",
    "title": "Hemisphere",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What two halves of Earth are created by the Prime Meridian according to the lesson?",
        "questionImage": "",
        "answers": [
          { "text": "Eastern and Western Hemispheres", "correct": true, "image": "" },
          { "text": "Northern and Southern Hemispheres", "correct": false, "image": "" },
          { "text": "Land and Sea Hemispheres", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What two halves of Earth are created by the Equator as explained in the song?",
        "questionImage": "",
        "answers": [
          { "text": "Northern and Southern Hemispheres", "correct": true, "image": "" },
          { "text": "Eastern and Western Hemispheres", "correct": false, "image": "" },
          { "text": "Daytime and Nighttime Hemispheres", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. How is the Prime Meridian described in the lyrics?",
        "questionImage": "",
        "answers": [
          { "text": "An imaginary line", "correct": true, "image": "" },
          { "text": "A river", "correct": false, "image": "" },
          { "text": "A mountain range", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. How is the Equator described in the lyrics?",
        "questionImage": "",
        "answers": [
          { "text": "An imaginary line", "correct": true, "image": "" },
          { "text": "A road around the Earth", "correct": false, "image": "" },
          { "text": "A country border", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What does the term Eastern Hemisphere mean in relation to the Prime Meridian?",
        "questionImage": "",
        "answers": [
          { "text": "The area east of the Prime Meridian", "correct": true, "image": "" },
          { "text": "The area south of the Equator", "correct": false, "image": "" },
          { "text": "The area west of the Prime Meridian", "correct": false, "image": "" }
        ]
      }
    ]
  },
  

  // Coordinates - Multiple Choice
  {
    "slug": "coordinates",
    "title": "Coordinates",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What do we use coordinates to find on a simple map grid in this lesson?",
        "questionImage": "",
        "answers": [
          { "text": "Location", "correct": true, "image": "" },
          { "text": "Weather", "correct": false, "image": "" },
          { "text": "Time", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. On a letter–number grid, what do we look at first to start finding a place?",
        "questionImage": "",
        "answers": [
          { "text": "Letter", "correct": true, "image": "" },
          { "text": "Picture", "correct": false, "image": "" },
          { "text": "Title", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. After the letter, what is the next thing we find on the grid to locate the spot?",
        "questionImage": "",
        "answers": [
          { "text": "Number", "correct": true, "image": "" },
          { "text": "Color", "correct": false, "image": "" },
          { "text": "Arrow", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Where do the letter and number meet to show the location on the map?",
        "questionImage": "",
        "answers": [
          { "text": "Grid square", "correct": true, "image": "" },
          { "text": "Compass", "correct": false, "image": "" },
          { "text": "Border", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What two things together make a simple map coordinate in this activity?",
        "questionImage": "",
        "answers": [
          { "text": "Letter and number", "correct": true, "image": "" },
          { "text": "Two colors", "correct": false, "image": "" },
          { "text": "Two arrows", "correct": false, "image": "" }
        ]
      }
    ]
  },
  

  // Native Contributions - Drag and Drop
  {
    "slug": "nativecontributions",
    "title": "Native Contributions",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each crop to the correct category from the song.",
        "options": [
          { "id": "corn", "text": "Corn", "image": "", "targetText": "Farming", "targetImage": "" },
          { "id": "tobacco", "text": "Tobacco", "image": "", "targetText": "Farming", "targetImage": "" },
          { "id": "beans", "text": "Beans", "image": "", "targetText": "Farming", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each craft to the art form mentioned in the lyrics.",
        "options": [
          { "id": "pottery", "text": "Pottery", "image": "", "targetText": "Art", "targetImage": "" },
          { "id": "weaving", "text": "Weaving", "image": "", "targetText": "Art", "targetImage": "" },
          { "id": "carving", "text": "Carving", "image": "", "targetText": "Art", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each idea to the value described in the song.",
        "options": [
          { "id": "respect", "text": "Respect for nature", "image": "", "targetText": "Value", "targetImage": "" },
          { "id": "knowledge", "text": "Learning about the environment", "image": "", "targetText": "Value", "targetImage": "" },
          { "id": "sharing", "text": "Sharing with others", "image": "", "targetText": "Value", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each word to what Native culture continues to do over time.",
        "options": [
          { "id": "culture", "text": "Culture", "image": "", "targetText": "Lives on", "targetImage": "" },
          { "id": "traditions", "text": "Traditions", "image": "", "targetText": "Continue", "targetImage": "" },
          { "id": "stories", "text": "Stories", "image": "", "targetText": "Passed down", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each phrase to the idea that Native contributions are still part of life today.",
        "options": [
          { "id": "today", "text": "Used today", "image": "", "targetText": "Contributions", "targetImage": "" },
          { "id": "influence", "text": "Influences", "image": "", "targetText": "Modern life", "targetImage": "" },
          { "id": "present", "text": "Present in culture", "image": "", "targetText": "Everyday life", "targetImage": "" }
        ]
      }
    ]
  },
  

  // Natural Resources - Drag and Drop
  {
    "slug": "naturalresources",
    "title": "Natural Resources",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each item to the type of resource that can replace itself over time.",
        "options": [
          { "id": "trees", "text": "Trees", "image": "", "targetText": "Renewable", "targetImage": "" },
          { "id": "fish", "text": "Fish", "image": "", "targetText": "Renewable", "targetImage": "" },
          { "id": "horses", "text": "Horses", "image": "", "targetText": "Renewable", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each fuel to the resource type that takes millions of years to form.",
        "options": [
          { "id": "oil", "text": "Oil", "image": "", "targetText": "Nonrenewable", "targetImage": "" },
          { "id": "gas", "text": "Natural Gas", "image": "", "targetText": "Nonrenewable", "targetImage": "" },
          { "id": "coal", "text": "Coal", "image": "", "targetText": "Nonrenewable", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each energy source that will not run out in our lifetime to its type.",
        "options": [
          { "id": "sunlight", "text": "Sunlight", "image": "", "targetText": "Inexhaustible", "targetImage": "" },
          { "id": "wind", "text": "Wind", "image": "", "targetText": "Inexhaustible", "targetImage": "" },
          { "id": "water", "text": "Flowing Water", "image": "", "targetText": "Inexhaustible", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each metal to the resource type that can be used again after recycling.",
        "options": [
          { "id": "copper", "text": "Copper", "image": "", "targetText": "Recyclable", "targetImage": "" },
          { "id": "tin", "text": "Tin", "image": "", "targetText": "Recyclable", "targetImage": "" },
          { "id": "aluminum", "text": "Aluminum", "image": "", "targetText": "Recyclable", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each key idea to the correct resource category from the song.",
        "options": [
          { "id": "renew_fact", "text": "Plants and Animals", "image": "", "targetText": "Renewable", "targetImage": "" },
          { "id": "nonrenew_fact", "text": "Takes millions of years", "image": "", "targetText": "Nonrenewable", "targetImage": "" },
          { "id": "recycle_fact", "text": "Can be reused", "image": "", "targetText": "Recyclable", "targetImage": "" }
        ]
      }
    ]
  },
  

  // Barter - Multiple Choice
  {
    "slug": "barter",
    "title": "Barter",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What does the word barter mean in the song?",
        "questionImage": "",
        "answers": [
          { "text": "To trade goods or services", "correct": true, "image": "" },
          { "text": "To print money", "correct": false, "image": "" },
          { "text": "To save coins", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. How common was money for most people long ago?",
        "questionImage": "",
        "answers": [
          { "text": "It was rare", "correct": true, "image": "" },
          { "text": "It was everywhere", "correct": false, "image": "" },
          { "text": "It was free to use", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What item was sometimes used like money for trading?",
        "questionImage": "",
        "answers": [
          { "text": "Tobacco", "correct": true, "image": "" },
          { "text": "Rocks", "correct": false, "image": "" },
          { "text": "Leaves", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. In bartering, what do people trade with each other?",
        "questionImage": "",
        "answers": [
          { "text": "Goods and services", "correct": true, "image": "" },
          { "text": "Only food", "correct": false, "image": "" },
          { "text": "Only land", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What would a farmer most likely do when money was not used?",
        "questionImage": "",
        "answers": [
          { "text": "Barter or trade items", "correct": true, "image": "" },
          { "text": "Borrow money from a bank", "correct": false, "image": "" },
          { "text": "Hide his goods", "correct": false, "image": "" }
        ]
      }
    ]
  },
  

  // Producer - Drag and Drop
  {
    "slug": "producer",
    "title": "Producer",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each economic role to what it does with goods or services.",
        "options": [
          { "id": "producer_goods", "text": "Producer", "image": "", "targetText": "Makes goods", "targetImage": "" },
          { "id": "producer_services", "text": "Producer", "image": "", "targetText": "Gives services", "targetImage": "" },
          { "id": "consumer", "text": "Consumer", "image": "", "targetText": "Uses goods or services", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each role to what it uses.",
        "options": [
          { "id": "consumer_goods", "text": "Consumer", "image": "", "targetText": "Uses goods", "targetImage": "" },
          { "id": "consumer_services", "text": "Consumer", "image": "", "targetText": "Uses services", "targetImage": "" },
          { "id": "producer_goods2", "text": "Producer", "image": "", "targetText": "Makes goods", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each type of work to the correct example.",
        "options": [
          { "id": "baker", "text": "Baker", "image": "", "targetText": "Makes goods", "targetImage": "" },
          { "id": "teacher", "text": "Teacher", "image": "", "targetText": "Gives services", "targetImage": "" },
          { "id": "doctor", "text": "Doctor", "image": "", "targetText": "Gives services", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match the word that means there are not enough resources to the right idea.",
        "options": [
          { "id": "scarce", "text": "Limited", "image": "", "targetText": "Resources", "targetImage": "" },
          { "id": "few", "text": "Few", "image": "", "targetText": "Supplies", "targetImage": "" },
          { "id": "not_enough", "text": "Not enough", "image": "", "targetText": "For everyone", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match the reason we must make choices to the concept that explains why.",
        "options": [
          { "id": "scarce2", "text": "Scarcity", "image": "", "targetText": "Causes choices", "targetImage": "" },
          { "id": "money", "text": "Money", "image": "", "targetText": "Used to buy goods", "targetImage": "" },
          { "id": "trade", "text": "Trade", "image": "", "targetText": "Exchange of goods", "targetImage": "" }
        ]
      }
    ]
  },
  

  // Responsible Citizen - Multiple Choice
  {
    "slug": "responsiblecitizen",
    "title": "Responsible Citizen",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. According to the song, what should responsible citizens do about laws?",
        "questionImage": "",
        "answers": [
          { "text": "Obey laws", "correct": true, "image": "" },
          { "text": "Break laws", "correct": false, "image": "" },
          { "text": "Ignore laws", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. When called for a civic duty, which role might a citizen serve?",
        "questionImage": "",
        "answers": [
          { "text": "Serve on a jury", "correct": true, "image": "" },
          { "text": "Attend a picnic", "correct": false, "image": "" },
          { "text": "Go to a parade", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What regular duty do responsible citizens pay as mentioned in the lyrics?",
        "questionImage": "",
        "answers": [
          { "text": "Pay taxes", "correct": true, "image": "" },
          { "text": "Skip taxes", "correct": false, "image": "" },
          { "text": "Hide taxes", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. When might responsible citizens serve in the armed forces according to the song?",
        "questionImage": "",
        "answers": [
          { "text": "If called to serve", "correct": true, "image": "" },
          { "text": "Only on weekends", "correct": false, "image": "" },
          { "text": "Never", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What should each of us aim to be based on the chorus?",
        "questionImage": "",
        "answers": [
          { "text": "A responsible citizen", "correct": true, "image": "" },
          { "text": "A careless driver", "correct": false, "image": "" },
          { "text": "A litter bug", "correct": false, "image": "" }
        ]
      }
    ]
  },
  

  // VA United - Multiple Choice
  {
    "slug": "vaunited",
    "title": "VA United",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. How do the lyrics describe the people of Virginia and the nation we belong to?",
        "questionImage": "",
        "answers": [
          { "text": "Americans", "correct": true, "image": "" },
          { "text": "Robots", "correct": false, "image": "" },
          { "text": "Aliens", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which civic action helps people choose leaders in our government?",
        "questionImage": "",
        "answers": [
          { "text": "Vote", "correct": true, "image": "" },
          { "text": "Litter", "correct": false, "image": "" },
          { "text": "Speed", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What do people do in local elections to help their communities?",
        "questionImage": "",
        "answers": [
          { "text": "Elect leaders", "correct": true, "image": "" },
          { "text": "Skip laws", "correct": false, "image": "" },
          { "text": "Close parks", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. How can people help make their communities better besides voting?",
        "questionImage": "",
        "answers": [
          { "text": "Volunteer", "correct": true, "image": "" },
          { "text": "Ignore problems", "correct": false, "image": "" },
          { "text": "Complain", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Where do the people of Virginia come from according to the song?",
        "questionImage": "",
        "answers": [
          { "text": "Many different places", "correct": true, "image": "" },
          { "text": "One small town", "correct": false, "image": "" },
          { "text": "One big family", "correct": false, "image": "" }
        ]
      }
    ]
  },
  

  // Pledge - Multiple Choice
  {
    "slug": "pledge",
    "title": "Pledge",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. Who is the leader of the United States as named in the song?",
        "questionImage": "",
        "answers": [
          { "text": "President", "correct": true, "image": "" },
          { "text": "King", "correct": false, "image": "" },
          { "text": "Duke", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What three colors are on the American flag according to the verse?",
        "questionImage": "",
        "answers": [
          { "text": "Red, white, and blue", "correct": true, "image": "" },
          { "text": "Green and gold", "correct": false, "image": "" },
          { "text": "Black and white", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What shapes appear as symbols on the American flag?",
        "questionImage": "",
        "answers": [
          { "text": "White stars", "correct": true, "image": "" },
          { "text": "Green stars", "correct": false, "image": "" },
          { "text": "Gold stars", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What do we recite when we face the American flag in this lesson?",
        "questionImage": "",
        "answers": [
          { "text": "The Pledge of Allegiance", "correct": true, "image": "" },
          { "text": "The National Poem", "correct": false, "image": "" },
          { "text": "The City Pledge", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. To which flag do we pledge our loyalty in the song?",
        "questionImage": "",
        "answers": [
          { "text": "The Flag of the United States", "correct": true, "image": "" },
          { "text": "The State Flag", "correct": false, "image": "" },
          { "text": "The Team Flag", "correct": false, "image": "" }
        ]
      }
    ]
  }
  
];

export default md2ndSocialStudiesQuizContent;
